module.exports = __webpack_public_path__ + "img/product13.75296a1b.png";